import React , { useState } from 'react'

import { ApiCallGet } from '../ApiCall/ApiCall'
import ShowFolio from '../ShowFolio/ShowFolio'
import LoadPhoto from './LoadPhoto'

export default function CargaPhotos() {
    const [foliocita,setFolioCita] = useState( "")
    const [showData,setShowData] = useState( false )
    const [myData,setMyData] = useState(null)

    function onAceptar()
    {
        console.log( "Folio Cita = " + foliocita )

        ApiCallGet( 'folio/' + foliocita )
        .then( (response) => {
            console.log( response )

            if ( response.length === 0 ){
                alert( "No se encontro el folio" )
                return ;
            }
            else{
                alert( "Se encontro el folio" )
                setMyData( response[0] )
                setShowData( true )
            }
            }
         )
        .catch( (error) => {
            console.log( error )
        })

    }
  return (
    
    <>
        <div className='row'>

            <div className='col-8'>
                <label className="form-label m-0" htmlFor="foliocita">Folio Cita</label>
                <input type="text" className="form-control" id="foliocita" onChange={(e) => setFolioCita(e.target.value)} />
            </div>

            <div className='col-4 pt-2'>
                <button type="button"  className="btn btn-primary mt-3 button-3" onClick={onAceptar} >Aceptar</button>
                
            </div>

            {
                showData && (
                    <>
                        <ShowFolio  datos={myData}></ShowFolio>
                        <LoadPhoto></LoadPhoto>
                    </>
                )

            }

        </div>
    </>
  )
}
